var colors = [
  {red: '#bb2727'},
  {tan: '#d2b48c'},
  {aqua: '#00ffff'},
  {blue: '#5770b7'},
  {cyan: '#00ffff'},
  {dirt: '#a54400'},
  {gold: '#D4AF37'},
  {gray: '#808080'},
  {grey: '#808080'},
  {lime: '#00ff00'},
  {navy: '#000080'},
  {nude: '#E3BC9A'},
  {mint: '#b6e4d0'},
  {peru: '#cd853f'},
  {pink: '#ffc0cb'},
  {plum: '#dda0dd'},
  {rust: '#b7410e'},
  {snow: '#fffafa'},
  {teal: '#008080'},
  {azure: '#f0ffff'},
  {beige: '#f5f5dc'},
  {black: '#000000'},
  {brown: '#a52a2a'},
  {cream: '#faf8d5'},
  {coral: '#ff7f50'},
  {green: '#008000'},
  {ivory: '#fffff0'},
  {khaki: '#f0e68c'},
  {linen: '#faf0e6'},
  {mauve: '#e0b0ff'},
  {olive: '#808000'},
  {wheat: '#f5deb3'},
  {white: '#f7f7f7'},
  {bisque: '#ffe4c4'},
  {indigo: '#4b0082'},
  {maroon: '#800000'},
  {orange: '#ffa500'},
  {orchid: '#da70d6'},
  {purple: '#800080'},
  {salmon: '#fa8072'},
  {sienna: '#a0522d'},
  {silver: '#c0c0c0'},
  {tomato: '#ff6347'},
  {violet: '#ee82ee'},
  {yellow: '#ffff00'},
  {crimson: '#dc143c'},
  {darkred: '#8b0000'},
  {dimgray: '#696969'},
  {fuchsia: '#ff00ff'},
  {hotpink: '#ff69b4'},
  {magenta: '#ff00ff'},
  {oldlace: '#fdf5e6'},
  {skyblue: '#87ceeb'},
  {thistle: '#d8bfd8'},
  {cornsilk: '#fff8dc'},
  {honeydew: '#f0fff0'},
  {lavender: '#e6e6fa'},
  {moccasin: '#ffe4b5'},
  {seagreen: '#2e8b57'},
  {seashell: '#fff5ee'},
  {rosegold: '#cf9fa6'},
  {darkblue: '#00008b'},
  {darkcyan: '#008b8b'},
  {darkgray: '#a9a9a9'},
  {darkgrey: '#a9a9a9'},
  {deeppink: '#ff1493'},
  {aliceblue: '#f0f8ff'},
  {burlywood: '#deb887'},
  {cadetblue: '#5f9ea0'},
  {chocolate: '#d2691e'},
  {darkgreen: '#006400'},
  {darkkhaki: '#bdb76b'},
  {firebrick: '#b22222'},
  {gainsboro: '#dcdcdc'},
  {goldenrod: '#daa520'},
  {indianred: '#cd5c5c'},
  {lawngreen: '#7cfc00'},
  {lightblue: '#add8e6'},
  {lightcyan: '#e0ffff'},
  {lightgray: '#d3d3d3'},
  {lightgrey: '#d3d3d3'},
  {lightpink: '#ffb6c1'},
  {limegreen: '#32cd32'},
  {mintcream: '#f5fffa'},
  {mistyrose: '#ffe4e1'},
  {olivedrab: '#6b8e23'},
  {orangered: '#ff4500'},
  {palegreen: '#98fb98'},
  {peachpuff: '#ffdab9'},
  {rosybrown: '#bc8f8f'},
  {royalblue: '#4169e1'},
  {slateblue: '#6a5acd'},
  {slategray: '#708090'},
  {slategrey: '#708090'},
  {steelblue: '#4682b4'},
  {turquoise: '#40e0d0'},
  {aquamarine: '#7fffd4'},
  {blueviolet: '#8a2be2'},
  {chartreuse: '#7fff00'},
  {darkorange: '#ff8c00'},
  {darkorchid: '#9932cc'},
  {darksalmon: '#e9967a'},
  {darkviolet: '#9400d3'},
  {dodgerblue: '#1e90ff'},
  {ghostwhite: '#f8f8ff'},
  {lightcoral: '#f08080'},
  {lightgreen: '#90ee90'},
  {mediumblue: '#0000cd'},
  {papayawhip: '#ffefd5'},
  {powderblue: '#b0e0e6'},
  {sandybrown: '#f4a460'},
  {whitesmoke: '#f5f5f5'},
  {darkmagenta: '#8b008b'},
  {deepskyblue: '#00bfff'},
  {floralwhite: '#fffaf0'},
  {forestgreen: '#228b22'},
  {greenyellow: '#adff2f'},
  {lightsalmon: '#ffa07a'},
  {lightyellow: '#ffffe0'},
  {navajowhite: '#ffdead'},
  {saddlebrown: '#8b4513'},
  {springgreen: '#00ff7f'},
  {yellowgreen: '#9acd32'},
  {antiquewhite: '#faebd7'},
  {darkseagreen: '#8fbc8f'},
  {lemonchiffon: '#fffacd'},
  {lightskyblue: '#87cefa'},
  {mediumorchid: '#ba55d3'},
  {mediumpurple: '#9370db'},
  {midnightblue: '#191970'},
  {darkgoldenrod: '#b8860b'},
  {darkslateblue: '#483d8b'},
  {darkslategray: '#2f4f4f'},
  {darkslategrey: '#2f4f4f'},
  {darkturquoise: '#00ced1'},
  {lavenderblush: '#fff0f5'},
  {lightseagreen: '#20b2aa'},
  {palegoldenrod: '#eee8aa'},
  {paleturquoise: '#afeeee'},
  {palevioletred: '#db7093'},
  {rebeccapurple: '#663399'},
  {blanchedalmond: '#ffebcd'},
  {cornflowerblue: '#6495ed'},
  {darkolivegreen: '#556b2f'},
  {lightslategray: '#778899'},
  {lightslategrey: '#778899'},
  {lightsteelblue: '#b0c4de'},
  {mediumseagreen: '#3cb371'},
  {mediumslateblue: '#7b68ee'},
  {mediumturquoise: '#48d1cc'},
  {mediumvioletred: '#c71585'},
  {mediumaquamarine: '#66cdaa'},
  {mediumspringgreen: '#00fa9a'},
  {lightgoldenrodyellow: '#fafad2'},
];

export function colorToHex(name) {
  var bg = '#E5E5E5';
  for (var i = 0; i < colors.length; i++) {
    var obj = colors[i];
    if (Object.keys(obj).toString() === name.toLowerCase().replace(/\s/g, '')) {
      return Object.values(obj)[0];
    }
  }
  return bg;
}
